<template>


  <div>
    <v-stepper v-model="e6" vertical style="border:0;box-shadow:none;">
      <v-stepper-step

              step="1"
      >
       Open the "Google Wifi app", on your device mobile device.
      </v-stepper-step>

      <v-stepper-content step="10"></v-stepper-content>


      <v-stepper-step step="2"
      >
       Tap on the settings icon (right-most icon in the navigation menu)
      </v-stepper-step>

      <v-stepper-content step="10">


      </v-stepper-content>



      <v-stepper-step step="3" >
       Under Settings section, tap "Network & General"
      </v-stepper-step>

      <v-stepper-content step="10">

      </v-stepper-content>

      <v-stepper-step step="4" >
       tap on "Advanced networking".
      </v-stepper-step>

      <v-stepper-content step="10">



      </v-stepper-content>

      <v-stepper-step step="5" >
       tap on "DNS"
      </v-stepper-step>

      <v-stepper-content step="10">

      </v-stepper-content>

      <v-stepper-step step="6" >
       select "Customised
      </v-stepper-step>

      <v-stepper-content step="10">

      </v-stepper-content>

      <v-stepper-step step="7" >
       In the "Primary server" and "Secondary" set GameEnable's DNS
      </v-stepper-step>

      <v-stepper-content step="10">
        <dns-ip-list></dns-ip-list>
      </v-stepper-content>

      <v-stepper-step step="8" >
        tap "Save"
      </v-stepper-step>

      <v-stepper-content step="10">

      </v-stepper-content>

    </v-stepper>


  </div>

</template>

<style scoped>

  >>> .v-stepper__label {
    color: rgba(0, 0, 0, 0.87)!important;
  }

</style>

<script>


  import dnsIpList from '../../../../components/dnsIpsList'
  // import i18n from '@/i18n';
  // import Page from '../mixins/page'


  export default {
    title: "Setup GameEnable's DNS for Google Wi-Fi router",
    name: 'set-router-dns/googlewifi',
    data: ()=>({
      e6:10
    }),
    components: {

      dnsIpList

    },
  };
</script>
